import React from 'react';
import PropTypes from 'prop-types';
import { Row } from 'react-bootstrap';
import moment from 'moment';
import CurrentPageContext from '../../../../../contexts/CurrentPageContext';
import styles from './Specials.scss';

export default class Specials extends React.Component {
  static propTypes = {
    discountPlans: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    facility: PropTypes.shape({
      settings: PropTypes.shape({
        enablePublicDescription: PropTypes.bool,
      }),
    }),
  };

  static defaultProps = {
    facility: {
      settings: {},
    },
  };

  static contextType = CurrentPageContext;

  renderDiscount(plan) {
    const { primaryColorClass } = this.context;

    const currentDate = moment().set({ hour: 23, minute: 59, second: 59, millisecond: 999 });

    const planEndDate = plan.endDate && moment(plan.endDate)
      .set({ hour: 23, minute: 59, second: 59, millisecond: 999 });

    const isPlanExpired = planEndDate ? (moment(planEndDate).isBefore(currentDate)) : false;

    if (isPlanExpired) {
      return null;
    }

    return (
      <li className={`${styles.special} ${primaryColorClass}`} key={plan.id}>
        <Row className={styles.promoRow}>
          {plan.publicDescription}
          {
            plan.endDate && plan.publicDescription
              ? (
                <small className={styles.expiration}>
                (Exp: {plan.endDate})
                </small>
              )
              : null
          }
        </Row>
      </li>
    );
  }

  renderDiscountPlans(plans) {
    const renderedPlans = [];

    plans.forEach((plan) => {
      if (plan.promotionType === 'promotion') {
        renderedPlans.unshift(this.renderDiscount(plan));
      } else {
        renderedPlans.push(this.renderDiscount(plan));
      }
    });

    return renderedPlans;
  }

  render() {
    const { discountPlans, facility: { settings: { enablePublicDescription } } } = this.props;

    return (
      <ul className={styles.specialsul}>
        {this.renderDiscountPlans(
          discountPlans.filter(plan => plan.autoApply && enablePublicDescription),
        )}
      </ul>
    );
  }
}
